import React, { Component } from 'react';
import {
  Button, Tabs,
} from 'antd';
import * as consts from '../../consts';
import './LoginPage.scss';
import { withRouter } from 'react-router';

const { TabPane } = Tabs;
const QR_TAB = '2';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToReferrer: false,
    };
    this.email = React.createRef();
    this.password = React.createRef();
    this.authQRStep1 = this.authQRStep1.bind(this);
  }

  componentDidMount() {
    this.authQRStep1();
  }

  authQRStep1() {
    const self = this.props;
    this.props.onLoginQR1Action({
      callback: () => {
        this.props.history.push('/');
      },
    });
  }

  handleChangeTab(tab) {
    if (tab === QR_TAB && this.props.login.expired) {
      this.authQRStep1();
    }
  }

  render() {
    return (
      <div style={{
        width: '100%',
        height: '100vh',
        background: 'linear-gradient(to top, #1CB5E0 0%, #1C1741 100%)',
      }}
      >
        <div className="wrap-login-component">
          <h4 className="text-center mb-medium mt-large text-white">Log in</h4>
          <div className="form-wrap">
            <Tabs
              defaultActiveKey="1"
              type="card"
              size="large"
            >
              <TabPane tab="Login with QR code" key="1" className="text-center">
                <div>
                  {
                    this.props.login.expired ? (
                      <div className="relative">
                        <div className="z-1 abs-center">
                          <Button type="primary" onClick={this.authQRStep1}>
                            Get new QR
                          </Button>
                        </div>
                        {this.props.login.qrStep1.image
                          ? (
                            <img
                              className="blur"
                              src={`data:image/png;base64,${this.props.login.qrStep1.image}`}
                            />
                          ) : ''}
                      </div>
                    )
                      : this.props.login.qrStep2.avatar
                        ? (
                          <>
                            <img
                              style={{
                                width: 96,
                                height: 96,
                                borderRadius: 100,
                              }}
                              src={this.props.login.qrStep2.avatar}
                            />
                            <div className="text-center">
                              {this.props.login.qrStep2.display_name}
                            </div>
                            <div>
                              Quét mã thành công. Vui lòng chọn "Confirm" trên thiết bị di động của
                              bạn.
                            </div>
                          </>
                        )
                        : (this.props.login.qrStep1.image
                          ? <img src={`data:image/png;base64,${this.props.login.qrStep1.image}`} /> : '')
                  }
                </div>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(LoginPage);
